import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';
import { RegisterService } from 'src/app/services/feature/register.service';
import { DeleteUserConfirmDialogComponent } from '../delete-user-confirm-dialog/delete-user-confirm-dialog.component';
import { UserRightsDialogComponent } from '../user-rights-dialog/user-rights-dialog.component';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
  standalone: false
})
export class CreateUserComponent {
  pageFieldData: any;
  accessRequestsWSList: any;
  countriesWSList: any;
  submitted: any;
  selectedRequestAccess: any = [];
  selectedIndustryRole: any = [];
  editUserInfo: any;
  userDetails$: any;
  showCustomerList: boolean = false;
  linkedCustomerList: any;
  RefactoredCustomerIdList: any;
  selected: boolean[] = [false];
  searchInput;
  userRightButtonClicked = false;
  stateList: any;
  private destroy$ = new Subject<void>();
  @HostListener('keydown.escape')
  @HostListener('document:click')
  onDocumentClick() {
    this.showCustomerList = false;
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }


  pageFieldData$ = this.registerService.getRegisterPageFields();
  createUserForm = new FormGroup(
    {
      email: new FormControl(null, [Validators.email, Validators.required]),
      industry: new FormControl(null),
      industryRole: new FormControl(null),
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      title: new FormControl(null),
      companyName: new FormControl(null, [Validators.required]),
      address1: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      zip: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      houseNumber: new FormControl(null),
      phone: new FormControl(null),
      fax: new FormControl(null),
      website: new FormControl(null),
      linkedCustomerList: new FormControl(null),
      requestAccessFor: new FormControl(null),
      selectFormControl: new FormControl(),
      searchTextboxControl: new FormControl()
    }
  );

  @ViewChild('search') searchTextBox: ElementRef;
  selectedValues = [];
  data: any;


  filteredOptions: Observable<any[]>;

  constructor(private registerService: RegisterService,
    private cdf: ChangeDetectorRef, private route: ActivatedRoute,
    private myCompanyAccountService: MyCompanyAccountService,
    private dialog: MatDialog, private translationService: TranslationService,
    private globalMessageService: GlobalMessageService, private router: Router) {

  }

  get f() {
    return this.createUserForm.controls;
  }

  ngOnInit() {
    this.registerService.getRegisterPageFields().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.pageFieldData = data;
      this.getUserDetails();
      this.accessRequestsWSList = this.pageFieldData.accessRequestsWSList.filter(item => item.code != 'DEALER_ADB');
      this.countriesWSList = this.pageFieldData.countriesWSList;

      this.cdf.detectChanges();
    })


  }

  onSubmit() {

  }

  getUserDetails() {
    this.userDetails$ = this.myCompanyAccountService.getCreateUserDetails();

    this.userDetails$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.editUserInfo = res;
      res.customerIdList.forEach((item) => {
        const selectedItem = res.editUserDetails.defaultSoldTo === item.uid;
        if (selectedItem) {
          item.selected = true;
        }
      });
      this.RefactoredCustomerIdList = res.customerIdList.filter(item=>item.uid == res.editUserDetails.defaultSoldTo);

      this.data = res.customerIdList;
      this.filteredOptions = this.createUserForm.controls.searchTextboxControl.valueChanges
        .pipe(
          startWith<string>(''),
          map(name => this._filter(name))
        );
      this.cdf.detectChanges();
    })
  }

  selectRequestAccess(ev, val) {
    const index = this.editUserInfo.editUserDetails.accessRequestCodes.findIndex(x => x === val.code);
    if (index > -1) {
      this.editUserInfo.editUserDetails.accessRequestCodes.splice(index, 1);
    } else {
      this.editUserInfo.editUserDetails.accessRequestCodes.push(val.code);
    }
  }

  selectIndustryRole(ev, val) {
    this.selectedIndustryRole = [];
    this.selectedIndustryRole.push(val.code);
    if (this.selectedIndustryRole.code === 'DISTRIBUTER') {
      this.accessRequestsWSList = this.pageFieldData.accessRequestsWSList;
    }
  }

  reset() {
    const exclude: string[] = ['selectFormControl', 'searchTextboxControl'];
    Object.keys(this.createUserForm.controls).forEach(key => {
      if (exclude.findIndex(q => q === key) === -1) {
        this.createUserForm.get(key).reset();
      }
    });
  }

  setUserRight(customerDetails) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'user-rights-popup';
    dialogConfig.data = this.editUserInfo.editUserDetails;

    if(this.editUserInfo.editUserDetails.accessRequestCodes.length > 0){
      if(this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("ORDER_ONLINE")>-1){
        dialogConfig.data.onlineOrdering = true;
        dialogConfig.data.viewPriceAndATP = true;
      }
      if (this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("CORE_REPORTS") > -1) {
        dialogConfig.data.coreRightsCodes.push('CORE_SUBMISSION', 'CORE_REPORTS');
      }
      if (this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("SUBMIT_WARRANTY") > -1) {
        dialogConfig.data.warrantyRightsCodes.push('WARRANTY_SEARCH', 'WARRANTY_CLAIM')
      }
    }

    const dialogRef = this.dialog.open(UserRightsDialogComponent, dialogConfig);

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data) {
          this.userRightButtonClicked = true;
          this.editUserInfo.editUserDetails.corePrice = data.coreCharge || false;
          this.editUserInfo.editUserDetails.listPrice = data.listPrice || false;
          this.editUserInfo.editUserDetails.netPrice = data.netPrice || false;
          this.editUserInfo.editUserDetails.coWorkerOrders = data.coWorkerInfo || false;
          this.editUserInfo.editUserDetails.viewPriceAndATP = data.priceAvail || false;
          this.editUserInfo.editUserDetails.priceDownloadAccess = data.downloadPriceFile || false;
          this.editUserInfo.editUserDetails.customerDocDownloadAccess = data.downloadCustomerDocs || false;
          this.editUserInfo.editUserDetails.updateMyPart = data.downLoadOwnPartNumber || false;
          this.editUserInfo.editUserDetails.warrantyRightsCodes = [];
          this.warrantyData(data);
          this.editUserInfo.editUserDetails.coreRightsCodes = [];
          if (data.coreSubmission) {
            this.editUserInfo.editUserDetails.coreRightsCodes.push('CORE_SUBMISSION')
          }
          if (data.coreReports) {
            this.editUserInfo.editUserDetails.coreRightsCodes.push('CORE_REPORTS')
          }
          this.editUserInfo.editUserDetails.accessRequestCodes = [];
          if (data.coreReports || data.coreSubmission) {
            this.editUserInfo.editUserDetails.accessRequestCodes.push('CORE_REPORTS');
          }
          if (data.warrantySearch || data.warrantyClaim) {
            this.editUserInfo.editUserDetails.accessRequestCodes.push('SUBMIT_WARRANTY');
          }
          if (data.onlineOrdering || data.priceAvail || data.coreCharge || data.listPrice) {
            this.editUserInfo.editUserDetails.accessRequestCodes.push('ORDER_ONLINE');
          }

         this.editUserInfo.editUserDetails.onlineOrdering = data.onlineOrdering|| false;
         this.editUserInfo.editUserDetails.technicalTrainingAccess = data.bookTechnicalTraining|| false;
         this.editUserInfo.editUserDetails.cutomerAdminFlag = data.customerAdmin || false;
         this.cdf.detectChanges();
        }
      }
    );
  }

  warrantyData(data) {
    if (data.warrantySearch) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_SEARCH')
    }
    if (data.warrantyClaim) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_CLAIM')
    }
    if (data.warrantyClaimValue) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_CLAIM_VALUE')
    }
  }

  selectedCust(e) {
    if (this.linkedCustomerList.filter(item => item.salesArea1 == e.salesArea1 && item.name == e.name).length == 0) {
      this.linkedCustomerList.push(e);
    }
  }

  removeLinkedAccount(data) {
    this.linkedCustomerList.forEach((element, i) => {
      if (element.salesArea1 == data.salesArea1 && element.name == data.name) {
        if (data.selected == true) {
          this.createUserForm.controls['linkedCustomerList'].setValue(this.linkedCustomerList[1].salesArea1 + this.linkedCustomerList[1].name);
        }
        this.linkedCustomerList.splice(i, 1);

      }
    });



  }

  selectLinkedCust(data, i) {
    this.linkedCustomerList[i].selected = true;
  }

  saveUser() {
    this.submitted = true;
    if (this.createUserForm.valid) {
      const unidIds = [];
      this.createUserForm.controls.selectFormControl.value.forEach(item => {
        unidIds.push(item.uid)
      });
      const payload = {
        uid: this.createUserForm.controls['email'].value,
        titleCode: this.createUserForm.controls['title'].value,
        firstName: this.createUserForm.controls['firstName'].value,
        lastName: this.createUserForm.controls['lastName'].value,
        companyName: this.createUserForm.controls['companyName'].value,
        companyCity: this.createUserForm.controls['city'].value,
        companyZip: this.createUserForm.controls['zip'].value,
        companyCountryCode: this.createUserForm.controls['country'].value,
        companyStateCode: this.createUserForm.controls['state'].value,
        companyPhoneNumber: this.createUserForm.controls['phone'].value,
        companyFaxNumber: this.createUserForm.controls['fax'].value,
        companyStreet: this.createUserForm.controls['address1'].value,
        companyAddressTwo: this.createUserForm.controls['houseNumber'].value,
        industryRoleCodes: this.selectedIndustryRole ? this.selectedIndustryRole : this.editUserInfo.editUserDetails.industryRoleCodes,
        accessRequestCodes: this.editUserInfo.editUserDetails.accessRequestCodes,
        unitIds: unidIds,

         corePrice:this.editUserInfo.editUserDetails.corePrice || false,
         listPrice:this.editUserInfo.editUserDetails.listPrice || false,
         netPrice:this.editUserInfo.editUserDetails.netPrice || false,
         coWorkerOrders:this.editUserInfo.editUserDetails.coWorkerOrders || false,
         viewPriceAndATP:this.editUserInfo.editUserDetails.viewPriceAndATP || false,
         priceDownloadAccess:this.editUserInfo.editUserDetails.priceDownloadAccess || false,
         customerDocDownloadAccess:this.editUserInfo.editUserDetails.customerDocDownloadAccess || false,
         updateMyPart:this.editUserInfo.editUserDetails.updateMyPart || false,
         warrantyRightsCodes:this.editUserInfo.editUserDetails.warrantyRightsCodes||[],
         coreRightsCodes:this.editUserInfo.editUserDetails.coreRightsCodes||[],
         onlineOrdering:this.editUserInfo.editUserDetails.onlineOrdering || false,
         technicalTrainingAccess:this.editUserInfo.editUserDetails.technicalTrainingAccess || false,
         cutomerAdminFlag:this.editUserInfo.editUserDetails.cutomerAdminFlag || false

      }
      this.myCompanyAccountService.saveUser(payload).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        if (data.status == 'SUCCESS') {
          this.router.navigate(['kbMycompanyCmsPage']);
        }
        if (data?.status == 'ERROR') {
          this.globalMessageService.add({ key: data.message }, GlobalMessageType.MSG_TYPE_ERROR);
        }

      })
    }
  }



  /**
 * Used to filter data based on search input
 */
  private _filter(name: string) {
  if (name !== null) {
  const filterValue = name.toLowerCase();
  // Set selected values to retain the selected checkbox state
  this.setSelectedValues();
  this.createUserForm.controls.selectFormControl.patchValue(this.selectedValues);
  //const filteredList = this.data.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
  const filteredList = this.data.filter((option) =>
  option.name?.toLowerCase().includes(filterValue) || option.salesArea1?.toLowerCase().includes(filterValue) ||
  option.salesArea2?.toLowerCase().includes(filterValue) || option.salesArea3?.toLowerCase().includes(filterValue)
  );
  return filteredList;
  }
  }

  /**
   * Remove from selected values based on uncheck
   */
  selectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      const index = this.selectedValues.indexOf(event.source.value);
      this.selectedValues.splice(index, 1)
    }
  }

  openedChange(e) {
    // Set search textbox value as empty while opening selectbox
    this.createUserForm.controls.searchTextboxControl.patchValue('');
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.searchTextBox.nativeElement.focus();
    }
  }

  /**
   * Clearing search textbox value
   */
  clearSearch(event) {
    event.stopPropagation();
    this.createUserForm.controls.searchTextboxControl.patchValue('');
  }

  /**
   * Set selected values to retain the state
   */
  setSelectedValues() {
    if (this.createUserForm.controls.selectFormControl.value && this.createUserForm.controls.selectFormControl.value.length > 0) {
      this.createUserForm.controls.selectFormControl.value.forEach((e) => {
        if (this.selectedValues.indexOf(e) == -1) {
          this.selectedValues.push(e);
        }
      });
    }
  }

  getStateList() {
    this.registerService.getRegions(this.createUserForm.controls['country'].value).pipe(takeUntil(this.destroy$)).subscribe((item: any) => {
      this.stateList = item?.regionsWSList;
      this.cdf.detectChanges();
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}


